import { useMemo } from 'react'
import { useAuthContext } from '../../../../context/auth.context'
import { useRoleOrgApiKey } from '../../../../role/hook/role-org'
import { holdsPlatformOnly } from './grant-words'
import { isKeyStaff } from './grants-access'

export const ROTATE_STAFF_ONLY = "Only EducationXR staff can rotate this key: it holds AI tools telemetry, which only EducationXR staff can give."

export const READ_ONLY_IMPERSONATING = "You're signed in as someone else, so API keys can be viewed but not changed. End the impersonation to make changes."

// What this person may do with the organization's keys (ruling 7): API_KEY
// create, update (rename, change the role, rotate) and delete (revoke), and
// never from an impersonated session, which content refuses (403
// auth.impersonation_not_allowed). Rotating a key that holds a platform-only
// resource (AI tools telemetry) is EducationXR staff's alone (403
// api_key.grants_staff_only): canRotate(key) says so per key, and
// rotateStaffOnly(key) says when that, not the person's rights, is why. The
// page offers no write it can't do; a refusal it didn't foresee still shows
// the server's message.
export const useKeyWrites = () => {
  const role = useRoleOrgApiKey()
  const { state } = useAuthContext()
  const impersonating = !!(state && state.jwtClaims && state.jwtClaims.impersonationEndsAt)
  const staff = isKeyStaff(state)
  // Booleans, so the answer (and the row menu built on it) only changes when a right does.
  const accessRead = !!role.accessRead
  const accessCreate = !!role.accessCreate
  const accessUpdate = !!role.accessUpdate
  const accessDelete = !!role.accessDelete

  return useMemo(() => {
    const couldWrite = accessCreate || accessUpdate || accessDelete
    const canUpdate = accessUpdate && !impersonating
    const staffOnly = key => !staff && holdsPlatformOnly(key)
    return {
      canRead: accessRead,
      canCreate: accessCreate && !impersonating,
      canUpdate,
      canDelete: accessDelete && !impersonating,
      canRotate: key => canUpdate && !staffOnly(key),
      rotateStaffOnly: key => canUpdate && staffOnly(key),
      readOnlyReason: impersonating && couldWrite ? READ_ONLY_IMPERSONATING : null
    }
  }, [accessRead, accessCreate, accessUpdate, accessDelete, impersonating, staff])
}
